import axios from 'axios';
import config from '../constants/config';
import { v4 as uuidv4 } from 'uuid';

const customersAxios = axios.create();
const customersService = {};

/**
 * Create customer
 * @param {import('../../../types/customers').CustomerDTO} data
 * @returns {AxiosPromise}
 */
customersService.createCustomer = (data) => {
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const token = user?.token || '';
  const url = `${config.BASEURL}v2/customers/`;
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    'X-Correlation-ID': uuidv4(),
  };

  return customersAxios.post(url, data, { headers });
};

/**
 * Update customer
 * @param {import('../../../types/customers').CustomerDTO} data
 * @returns {AxiosPromise}
 */
customersService.updateCustomer = (customerId, data) => {
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const token = user?.token || '';
  const url = `${config.BASEURL}v2/customers/${customerId}`;
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    'X-Correlation-ID': uuidv4(),
  };

  return customersAxios.patch(url, data, { headers });
};

/**
 * Get list of customers for the current location
 * @param {{onlyActiveCustomers: boolean}} options
 * @returns
 */
customersService.getCustomersList = (options) => {
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const token = user?.token || '';
  const url = `${config.BASEURL}v2/customers/`;
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  return customersAxios.get(url, { headers, params: options });
};

/**
 * Get all of the payment methods in the same format for a customer
 * @param {string} customerId
 * @returns {AxiosPromise}
 */
customersService.getPaymentMethods = (customerId) => {
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const token = user?.token || '';
  const url = `${config.BASEURL}v2/customers/${customerId}/paymentMethods`;
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  return customersAxios.get(url, { headers });
};

export default customersService;
